<template>
  <div class="container">
    <!-- Explicação inicial -->
    <div class="intro">
      <h1>Bem-vindo ao Utilitários Diversos</h1>
      <p>
        Este site fornece ferramentas úteis para seu dia a dia. Use o menu lateral para acessar conversores de texto, resumos e muito mais!
      </p>
    </div>

    <div class="content">
      <!-- Coluna Esquerda -->
      <div class="column">
        <h2>🕒 Hora Atual</h2>
        <p class="time">{{ localTime }}</p>

        <h2>📅 Calendário</h2>
        <div class="calendar">
          <table>
            <thead>
              <tr>
                <th v-for="day in days" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="week in calendar" :key="week">
                <td v-for="day in week" :key="day" :class="{ today: day === currentDay }">
                  {{ day }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>💰 Cotações</h2>
        <p><b>Dólar:</b> R$ {{ dolarRate }}</p>
        <p><b>Euro:</b> R$ {{ euroRate }}</p>
      </div>

      <!-- Coluna Direita -->
      <div class="column">
        <h2>📝 Bloco de Notas</h2>
        <textarea v-model="notes" @input="saveNotes" placeholder="Digite suas anotações aqui..."></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";

export default {
  name: "HomePage",
  setup() {
    const localTime = ref(new Date().toLocaleTimeString());

    // Atualiza a hora local
    setInterval(() => {
      localTime.value = new Date().toLocaleTimeString();
    }, 1000);

    // Salva anotações nos cookies
    const notes = ref(localStorage.getItem("notes") || "");
    const saveNotes = () => {
      localStorage.setItem("notes", notes.value);
    };

    // Calendário
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentDay = currentDate.getDate();
    const days = ["D", "S", "T", "Q", "Q", "S", "S"];
    const calendar = ref([]);

    const generateCalendar = () => {
      let firstDay = new Date(currentYear, currentMonth, 1).getDay();
      let daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      let weeks = [];
      let week = new Array(firstDay).fill("");

      for (let day = 1; day <= daysInMonth; day++) {
        week.push(day);
        if (week.length === 7) {
          weeks.push(week);
          week = [];
        }
      }
      if (week.length) weeks.push(week);
      calendar.value = weeks;
    };

    // Obter Cotações
    const dolarRate = ref("Carregando...");
    const euroRate = ref("Carregando...");

    const getRates = async () => {
      try {
        const response = await axios.get("https://api.exchangerate-api.com/v4/latest/USD");
        dolarRate.value = response.data.rates.BRL.toFixed(2);
        euroRate.value = response.data.rates.EUR.toFixed(2);
      } catch (error) {
        dolarRate.value = "Erro";
        euroRate.value = "Erro";
      }
    };

    onMounted(() => {
      generateCalendar();
      getRates();
    });

    return { localTime, notes, saveNotes, dolarRate, euroRate, days, calendar, currentDay };
  }
};
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: auto;
  padding: 20px;
  font-family: "Arial", sans-serif;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
}

.content {
  display: flex;
  gap: 20px;
}

.column {
  width: 48%;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  text-align: left;
  line-height: 1.6;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #007bff;
}

.time {
  font-size: 24px;
  font-weight: bold;
}

.calendar table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.calendar th, .calendar td {
  padding: 8px;
  border: 1px solid #ccc;
}

.today {
  background: yellow;
  font-weight: bold;
}

textarea {
  width: 100%;
  height: 400px; /* Duplicamos a altura */
  padding: 10px;
  border-radius: 5px;
}
</style>
